import styled from 'styled-components'

interface CellContentProps {
  isCopied: boolean
}

export const StyledTableCell = styled.td<{
  hasTextWrapping: boolean
  enableTextFading?: boolean
  columnWidth?: string
}>`
  ${({ hasTextWrapping }) =>
    hasTextWrapping &&
    `
    white-space: normal;
    word-wrap: break-word;
  `}

  ${({ enableTextFading, columnWidth }) =>
    !!(enableTextFading && columnWidth) && `max-width: ${columnWidth};`}

  a {
    text-decoration: underline;
    color: #303032;
  }
`

export const CellContent = styled.span<CellContentProps>`
  background-color: ${({ isCopied }) => (isCopied ? '#d4edda' : 'inherit')};
  padding: 0 2px;
  border-radius: 2px;
  line-height: 1.4;
  transition: ${({ isCopied }) =>
    isCopied ? 'background-color 0.3s ease;' : 'none'};
  display: block;
`

export const EditableCell = styled.td`
  padding: 0;
`
